import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, withRouter, Redirect, useLocation } from 'react-router-dom'
import { tasksApi } from '../../../../api/tasksApi'
import { routes } from '../../../../constantes/routes'
import TasksForm from '../TasksForm'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import Header from '../../../header/Header'
import { tasksActions } from '../../../../actions/tasksActions'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import { swalMssgs } from '../../../../constantes/swalMssgs'
import validators from '../../../../utils/validationsRegEx'
import { hospitalsContactsActions } from '../../../../actions/hospitalsContactsActions'

const NewTaskContainer = () => {
  const history = useHistory()
  const location = useLocation()

  // Detectar parámetros de URL
  const searchParams = new URLSearchParams(location.search)
  const dateFromCalendar = searchParams.get('date')
  const fromCalendar = searchParams.get('from') === 'calendar'

  const hospitalsContacts = useSelector((state) => state.hospitalsContacts)
  const events = useSelector((state) => state.events)
  const phases = useSelector((state) => state.phases)
  const businessunits = useSelector((state) => state.businessunits)
  const userProfile = useSelector((state) => state.userProfile)

  const dispatch = useDispatch()

  const newTask = (task) => dispatch(tasksActions.newTask(task))

  const [inputs, setinputs] = useState({
    id_Usuario: '',
    id_Contacto: '',
    id_TipoFase: '',
    id_TipoAsunto: '',
    asunto: '',
    fecha: dateFromCalendar || '', // Usar fecha del calendario si está disponible
    descripcion: '',
    isVerCaledario: fromCalendar || false, // Marcar para ver en calendario si viene del calendario
    businessUnits: [],
  })
  const [isDisable, setIsDisable] = useState(false)

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      dispatch(businessunitsActions.getAllBusinessUnits())
    }
    dispatch(hospitalsContactsActions.getAllContactsHospitals())
  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...taskData } = inputs
      const dataToSend = {
        ...taskData,
        id_NegocioUnidades: businessUnits || [],
      }
      await newTask(dataToSend)
      swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
      // Navegar según de dónde viene
      if (fromCalendar) {
        history.push(routes.CALENDAR)
      } else {
        history.push(routes.MANAGEMENT)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
    }
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs.id_Contacto) &&
      validators.hasValue(inputs.id_TipoFase) &&
      //&& validators.hasValue(inputs.id_TipoZona)
      validators.hasValue(inputs.id_TipoAsunto) &&
      validators.hasValue(inputs.fecha) &&
      inputs.businessUnits &&
      inputs.businessUnits.length > 0
    )
  }

  const handleChange = (event) => {
    const name = event.target.name
    const value =
      name === 'isVerCaledario' ? event.target.checked : event.target.value

    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const toManagement = () => {
    if (fromCalendar) {
      history.push(routes.CALENDAR)
    } else {
      history.push(routes.MANAGEMENT)
    }
  }

  return (
    <>
      {
        <div className='history-wrap'>
          <div className='products'>
            <Header text={'Nuevo lead'} route={toManagement} backBtn={true} />
            <TasksForm
              inputs={inputs}
              contacts={hospitalsContacts}
              events={events}
              phases={phases}
              businessunits={businessunits}
              isDisable={isDisable || !validateForm()}
              handleSubmit={handleSubmit}
              handleChange={handleChange}
              readOnly={false}
              textBtn={onSubmitText.Crear}
            />
          </div>
        </div>
      }
    </>
  )
}
export default withRouter(NewTaskContainer)
